<template>
    <div>
        <div class="modal-container">

            <div class="modal-header">
                 Verify Access Code
            </div>

            <div class="modal-body">
                Please enter the code that was sent to your email account to verify your access.
                If you did not receive it in your inbox please be sure to check your junk-email folder.
                You can also click <a href="" @click.prevent="resend">here</a> to have it resent.
                <form @submit.prevent="checkCode">
                    <div class="top20 has-text-centered" >
                        <input id="textInput" type="text" class="input has-text-centered is-warning is-focused" v-model="code"/>
                        <div class="has-text-danger" v-show="showError">
                            Invalid Code
                        </div>
                        <div  v-show="showSent">
                            New code has been sent
                        </div>
                    </div>
                    <div class="body-bott">
                        <button type="submit" id="codeButt" class="button is-coolGreen is-pulled-right">
                            OK
                        </button>
                        <button class="button is-pulled-right" @click="cancel">
                            Cancel
                        </button>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data: function () {
    var code = ''
    var cu = {}
    return {
      code,
      cu,
      showError: false,
      showSent: false
    }
  },
  mounted: function () {
      document.getElementById("textInput").focus();
  },
  methods: {
    checkCode: function () {
      var self = this

      this.showSent = false
      this.showError = false

      if (this.code == '') {
        return
      }

      az.addRemSpinner(true, 'id', 'codeButt');

      self.$root.app.azCognito.checkVerificationCode(self.code, verificationEmailCallback)

      function verificationEmailCallback (result, obj) {
        az.addRemSpinner(false, 'id', 'codeButt');
        if (result == 'error') {
          if (obj.code == 'CodeMismatchException') {
            self.showError = true
          }
          return
        }
        self.$root.app.userAttrs.email_verified = true
        self.$root.app.isAuth = true
        self.$emit('close')
      }
    },
    resend: function () {
      var self = this
      self.showSent = false
      self.showError = false

      self.$root.app.azCognito.resendVerificationCode(resendCodeCallback)

      function resendCodeCallback (result, obj) {
        if (result == 'error') {
          if (obj.code == 'LimitExceededException') {
            self.$root.app.showModalOK({message: 'You have reached the limit for codes sent. Please try again later.'})
          }
          return
        }
        self.showSent = true
      }
    },
    cancel: function () {
      this.$root.app.azCognito.logOutUser(null)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
    .modal-container{
        width: 350px;
        height: 350px;
    }
    .body-bott{
        position: absolute;
        margin-left: -10px;
        bottom: 15px;
        right: 10px;
        width: 100%;
    }
    .body-bott .button{
        margin-left: 10px;
        /* position: absolute;
        right: 30px;
        bottom: 10px; */
    }
    #textInput{
        width: 150px;
    }
    a{
        font-weight: bold;
        color: #F75;

    }
    a:hover{
        color:gold
    }
</style>
